import React, { useEffect, useState } from 'react';
import './styles/main.scss';
import AcountsHeader from 'components/common/tables_header/accounts';
import CreateDepartmentTable from 'components/tables/create_department';
import CreateServiceTable from 'components/tables/create_service';
import useMember from 'hooks/useMember';
import { useQuery } from 'react-query';
import { CustomInput } from 'components/custom';
import useAuth from 'hooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';
type ConfigurationProps = {
  addDepartment?: (data) => void;
  addService?: (data) => void;
  setDepartment?: (status) => void;
  setService?: (status) => void;
  createDepartment?: boolean;
  createService?: boolean;
};
const Configuration = ({
  addDepartment,
  addService,
  setDepartment,
  setService,
  createService,
  createDepartment,
}: ConfigurationProps) => {
  const [state, setState] = useState({
    usersData: [],
    departmentListData: [],
  });
  const { departmentListData } = state;
  const { user } = useAuth();
  const { getUsersList, departmentList } = useMember();
  const usersList = useQuery('get-users-list', getUsersList, {
    refetchOnWindowFocus: false,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const addDepartmentToTable = (data) => {
    setState((pre) => ({
      ...pre,
      departmentListData: [...departmentList, data],
    }));
  };
  useEffect(() => {

    const timeoutId = setTimeout(() => {
      const targetElement = document.getElementById(`${location.state}`);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',

        });
        navigate('', { state: null });
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    setState((pre) => ({
      ...pre,
      departmentListData: departmentList,
    }));
  }, [departmentList]);

  return (
    <div className={'tab_children'}>

      <section className={'function_container'}>
        <h1 className={'function_title'} style={{ margin: '32px 0' }}>
          Organization
        </h1>
        <div className={'function_wrapper'} style={{ background: '#FFF' }}>
          <h2 style={{ fontSize: '20px', color: '#000000', fontWeight: 500, marginBottom: 32 }}>
            Company Manager
          </h2>
          <CustomInput
            value={user?.first_name + ' ' + user?.last_name}
            style={{ width: '100%' }}
            title="Admin"
          />
        </div>
      </section>

      <section style={{ marginTop: 50 }} className={'function_container'} id="department">
        <CreateDepartmentTable
          addDepartmentToTable={addDepartmentToTable}
          departmentList={departmentListData}
          usersData={usersList?.data}
          addDepartment={addDepartment}
          createDepartment={createDepartment}
          setDepartment={setDepartment}
        />
      </section>
      <section style={{ marginTop: 50 }} className={'function_container'} id="service">
        <CreateServiceTable
          setService={setService}
          departmentList={departmentList}
          usersData={usersList?.data}
          addService={addService}
          createService={createService}
        />
      </section>
      <section style={{ marginTop: 50 }} className={'function_container'}>
        <div className={'function_wrapper'}>
          <h2 style={{ fontSize: '20px', color: '#000000', fontWeight: 500 }}>
            Associated Accounts
          </h2>
          <button className="add_user_second_step_button">
            <img src="/icons/new_button.svg" alt="button" />
            Add item
          </button>
          <div
            className="employee_directory_filter_table"
            style={{ width: '100%', marginTop: '30px' }}
          >
            <AcountsHeader />
            {/* <WorkShiftCalendar
              onClose={onClose}
              data={[]}
              addCalendar={addCalendar}
            /> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Configuration;
